import Component from '@bythepixel/component-loader';
import BaseForm from './base';

export default class PartsPickUpForm extends Component {
  static selector = '[data-comp-form-parts-pick-up]'

  constructor(containerEl) {
    super(containerEl);

    // eslint-disable-next-line no-new
    new BaseForm(containerEl, `${this.$id}_secureInput`, '/api/leads/parts-pick-up', () => {
      // Updates the event label for GA tracking analytics
      const locationField = this.$container.querySelector('select[name="location"]');
      this.$container.dataset.eventLabel = locationField.value;
    });
  }
}
